import { AssetUrls } from 'config/assets';
import './LoadingIndicator.css';

interface Props {
  message?: string;
  isScreen?: boolean;
}
export const LoadingIndicator = ({ message, isScreen }: Props) => {
  const Icon = (
    <img
      className="loading-indicator-icon"
      src={AssetUrls.logos.iconLogo}
      width={50}
      height={50}
      alt="icon-logo"
    />
  );
  if (isScreen) {
    return (
      <div className="loading-indicator-screen">
        {Icon}
        {message && <div className="loading-text">{message}</div>}
      </div>
    );
  }
  return Icon;
};
